<script>
	export let type = 'submit';
</script>

<button {type}>
	<slot></slot>
</button>